import React from 'react';
import './Newsletter.css';
import { SubHeading } from '..';

// Optional: import icons if you're using something like react-icons
import { FaFacebookF, FaInstagram } from 'react-icons/fa';

const Newsletter = () => (
  <div className='app__newsletter'>
    <div className="app__newsletter-heading">
      <SubHeading title="NewsLetter" />
      <h1 className="headtext__cormorant">Subscribe to our Social Media</h1>
      <p className="p__opensans">Never miss any updates</p>
    </div>

    <div className="app__newsletter-input flex__center">
      <a 
        href="https://www.facebook.com/profile.php?id=61575668380212" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="social__link"
      >
        <FaFacebookF size={24} />
      </a>
      <a 
        href="https://www.instagram.com/kamathansw/" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="social__link"
      >
        <FaInstagram size={24} />
      </a>
    </div>
  </div>
);

export default Newsletter;
